import {Component, OnInit} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {Observable} from 'rxjs';
import {SelectItemGroup} from 'primeng/api';
import {CourseService} from '@app/@core/services/course.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-field-course-select',
    template: `
        <ng-container *ngIf="to.multiple;else templateSingle">
            <p-multiSelect [class.ng-dirty]="showError"
                           [placeholder]="to.placeholder"
                           [options]="courses | async"
                           [formControl]="formControl"
                           [formlyAttributes]="field"
                           [selectedItemsLabel]="'{0} items selected'"
                           [group]="true"
                           defaultLabel="Select a Course"
                           ngDefaultControl>
            </p-multiSelect>
        </ng-container>

        <ng-template #templateSingle>
            <p-dropdown [class.ng-dirty]="showError"
                        [placeholder]="to.placeholder"
                        [options]="courses | async"
                        [formControl]="formControl"
                        [formlyAttributes]="field"
                        [group]="true"
                        [filter]="true"
                        filterBy="label"
                        defaultLabel="Select a Course"
                        ngDefaultControl>
            </p-dropdown>
        </ng-template>
    `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldCourseSelect extends FieldType implements OnInit {
    courses: Observable<SelectItemGroup[]>;

    constructor(private courseService: CourseService) {
        super();
    }

    ngOnInit(): void {
        if (this.to.required) {
            this.courses = this.courseService.groupedOptions$;
        } else {
            this.courses = this.courseService.groupedOptionsNotRequire$;
        }
    }
}
